export enum ECurriculumUrls {
  CURRICULUM = 'curriculum',
  APPLICATION = 'application',
}
